export function getDeltaBasedOnOrder(
  index: number, // zero-indexed number of current button
  numberOfButtons: number, // Total number of buttons (number of panels)
  buttonHeight = 36,
  buttonMargin = 6
) {
  const overallHeight =
    buttonHeight * numberOfButtons + buttonMargin * (numberOfButtons - 1);

  const initialTopMargin = Math.floor(-overallHeight / 2);

  const relativePosition = buttonHeight * index + buttonMargin * index;

  return initialTopMargin + relativePosition;
}
